import { render } from "./AiFavorableCommentsDetails.vue?vue&type=template&id=4e1c778f&scoped=true"
import script from "./AiFavorableCommentsDetails.vue?vue&type=script&lang=js"
export * from "./AiFavorableCommentsDetails.vue?vue&type=script&lang=js"

import "./AiFavorableCommentsDetails.vue?vue&type=style&index=0&id=4e1c778f&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1c778f"]])

export default __exports__